import type { Drama } from '@/types/content';

interface SynopsisSectionProps {
  drama: Drama;
}

export default function SynopsisSection({ drama }: SynopsisSectionProps) {
  return (
    <section id="synopsis" className="w-full scroll-mt-24 border-b border-background-200 bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-content px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <p className="mb-2 flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-primary-600">
              <span className="h-px w-8 bg-primary-400" aria-hidden="true" />
              Full Season
            </p>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">全季剧情梗概</h2>
            <p className="mt-5 text-sm leading-8 text-foreground-700 md:text-[15px]">{drama.synopsis}</p>

            <div className="mt-8 rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
              <h3 className="font-heading text-base font-bold text-foreground-950">主线脉络一览</h3>
              <ol className="mt-4 space-y-3">
                {drama.episodes.map((episode, index) => (
                  <li key={episode.no} className="flex gap-3">
                    <span className="font-display mt-0.5 text-accent-600">
                      {String(index + 1).padStart(2, '0')}
                    </span>
                    <span className="text-sm leading-6 text-foreground-700">
                      <span className="text-foreground-950">第 {episode.no} 集「{episode.title}」</span>
                      ：{episode.summary}
                    </span>
                  </li>
                ))}
              </ol>
            </div>
          </div>

          <aside className="lg:col-span-4">
            <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
              <h3 className="font-heading text-base font-bold text-foreground-950">剧集档案</h3>
              <dl className="mt-4 space-y-3 text-sm">
                <div className="flex items-center justify-between border-b border-background-200 pb-3">
                  <dt className="text-foreground-500">剧名</dt>
                  <dd className="text-foreground-900">{drama.title}</dd>
                </div>
                <div className="flex items-center justify-between border-b border-background-200 pb-3">
                  <dt className="text-foreground-500">题材</dt>
                  <dd className="text-foreground-900">{drama.category}</dd>
                </div>
                <div className="flex items-center justify-between border-b border-background-200 pb-3">
                  <dt className="text-foreground-500">总集数</dt>
                  <dd className="text-foreground-900">{drama.totalEpisodes} 集</dd>
                </div>
                <div className="flex items-center justify-between border-b border-background-200 pb-3">
                  <dt className="text-foreground-500">更新状态</dt>
                  <dd className={drama.status === '已完结' ? 'text-foreground-900' : 'text-primary-600'}>
                    {drama.status}
                  </dd>
                </div>
                <div className="flex items-start justify-between gap-4">
                  <dt className="shrink-0 text-foreground-500">更新节奏</dt>
                  <dd className="text-right leading-6 text-foreground-900">{drama.schedule}</dd>
                </div>
              </dl>

              <div className="mt-5 flex flex-wrap gap-1.5">
                {drama.tags.map((tag) => (
                  <span key={tag} className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}